export const POPPER_HIDE = 'POPPER_HIDE';

export const hidePopper = () => ({
  type: POPPER_HIDE,
});
